module.exports = "/_next/static/images/associationLogo2-f17e250aa8e72ccca5283163436175d9.webp";